import { CommandBarButton } from "@fluentui/react";
import React, { useContext } from "react";

import { OrderListingContext } from "../../listing/context/OrderListingContext";

export const ClearSelectedOrdersButton: React.VFC = () => {
    const { selectedItems, setSelectedItems } = useContext(OrderListingContext);

    const clear = () => {
        setSelectedItems([]);
    };

    return !selectedItems.length ? (
        <></>
    ) : (
        <CommandBarButton
            iconProps={{ iconName: "Cancel" }}
            onClick={clear}
            text={`${selectedItems.length} selected`}
        />
    );
};
